import { useMutation, useQuery } from '@tanstack/react-query';

import useAgent from 'Lib/hooks/api/useAgent';

const endpoint = 'pods';

export const usePods = () => {
	return useQuery({
		queryKey: [endpoint]
	});
};

export const useSetActivePod = (onSuccess, onError) => {
	const { post } = useAgent();

	return useMutation({
		mutationKey: [endpoint, 'set'],
		mutationFn: async payload => {
			return await post('pods/set', null, payload);
		},
		onSuccess,
		onError
	});
};
